import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Checkbox, Row, Col } from 'react-bootstrap';

import Heading from '../components/Heading';
import AgreementList from '../components/Agreements/AgreementList';
import DealsList from '../components/Deals/DealsList';

import {
  selectDealsState,
  selectInvitesState,
  selectAgreementsState,
} from '../redux/selectors';
import SearchBar from '../components/SearchBar';

class Agreements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      showArchivedDeal: false,
    };
  }

  handleNewDeal() {
    // This isn't in use right now. If we use it, it will be to create a new standalone deal.
    this.props.router.push('/create-deal');
  }

  handleSearch = (e) => {
    e.preventDefault();
    this.setState({ searchText: e.target.value });
  };

  clearSearch = (e) => {
    e.preventDefault();
    this.setState({ searchText: '' });
  };

  handleDealStatus() {
    this.setState((state) => ({
      showArchivedDeal: !state.showArchivedDeal,
    }));
  }

  render() {
    const { searchText, showArchivedDeal } = this.state;

    return (
      <div className="agreement-list-page">
        <Heading text="Agreements" />

        <Row>
          <Col md={12}>
            <div className="text-center button-list">
              <a
                type="button"
                className="btn btn-link btn-register-new"
                href="/create/new"
              >
                Create New Agreement
              </a>
              <a
                type="button"
                className="btn btn-link btn-register-new"
                href="/create/exist"
              >
                Add Works to An Existing Agreement
              </a>
            </div>
          </Col>
        </Row>

        <Row className="agreement-intro">
          <Col>
            <h4 className="text-center">
              Here you'll find all of the Agreements you've sent, been invited
              to, and completed.
            </h4>
          </Col>
        </Row>

        <div className="agreement-page">
          <SearchBar
            searchText={searchText}
            handleSearch={this.handleSearch}
            clearSearch={this.clearSearch}
          />

          <Row className="checkbox-archived-deal">
            <Col md={12} className="text-center">
              <Checkbox
                className="btn-archived-deal"
                checked={showArchivedDeal}
                onChange={() => this.handleDealStatus()}
              >
                Show Archived Agreements
              </Checkbox>
            </Col>
          </Row>

          <Row>
            <Col md={8}>
              <DealsList
                searchText={searchText}
                showArchivedDeal={showArchivedDeal}
              />
            </Col>
            <Col md={4}>
              <AgreementList type="view" searchText={searchText} />
            </Col>
          </Row>
          <br />
          <br />

          <Row>
            <Col md={12}>
              <p style={{ marginLeft: 20 }}>
                Need assistance navigating around?
              </p>
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://cosynd.zendesk.com/hc/en-us/articles/115015594847-How-to-Create-a-Simple-Split-Sheet-Agreement"
                  >
                    How to Create a Simple Split Sheet Agreement
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://cosynd.zendesk.com/hc/en-us/articles/115015679748-How-to-Create-a-Premium-Ownership-Agreement"
                  >
                    How to Create a Premium Ownership Agreement
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://cosynd.zendesk.com/hc/en-us/articles/115015679728-How-to-Create-a-Work-for-Hire-Agreement"
                  >
                    How to Create a Work for Hire Agreement
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://cosynd.zendesk.com/hc/en-us/articles/360001708408-How-to-Review-and-Complete-an-Agreement-You-Have-Been-Invited-to"
                  >
                    How to Review and Complete an Agreement You Have Been
                    Invited to
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://cosynd.zendesk.com/hc/en-us/articles/360001717767-How-to-Add-New-Works-to-Your-Existing-Agreements"
                  >
                    How to Add New Works to Your Existing Agreements
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  deals: selectDealsState(state),
  invites: selectInvitesState(state),
  finalizedDeals: selectAgreementsState(state, props),
});

export default connect(mapStateToProps, null)(withRouter(Agreements));



// WEBPACK FOOTER //
// src/pages/Agreements.jsx